export const escapeHtml = (value: string) =>
    value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

const textBlockTags = new Set(["DIV", "P", "H2", "H3"]);

export const getSelectionElement = () => {
    const selection = window.getSelection();
    const node = selection?.rangeCount ? selection.getRangeAt(0).commonAncestorContainer : null;
    return node instanceof HTMLElement ? node : node?.parentElement || null;
};

export const getTextBlock = (element: HTMLElement | null, editor: HTMLElement) => {
    let current: HTMLElement | null = element;

    while (current && current !== editor) {
        if (textBlockTags.has(current.tagName)) return current;
        current = current.parentElement;
    }

    return null;
};

export const normalizeChecklistLists = (editor: HTMLElement) => {
    editor
        .querySelectorAll('ul[data-checklist="true"] ul')
        .forEach((list) => list.setAttribute("data-checklist", "true"));

    editor
        .querySelectorAll('ul[data-checklist="true"] li')
        .forEach((item) => {
            if (!item.getAttribute("data-checked")) {
                item.setAttribute("data-checked", "false");
            }
        });
};

export const buildTableHtml = (rows: number, columns: number) => {
    const tableRows = Array.from({ length: rows }, () => {
        const cells = Array.from({ length: columns }, () => "<td><br></td>").join("");
        return `<tr>${cells}</tr>`;
    }).join("");

    return `<table><tbody>${tableRows}</tbody></table><div><br></div>`;
};
